import { CompanySuggestionEnum } from '~/src/components/common-components/company-suggestion/company-suggestion.enum';
import { COLORS } from '~/src/styles/tokens/colors';

export const getBackgroundColor = (status: keyof typeof CompanySuggestionEnum): string => {
    switch (CompanySuggestionEnum[status]) {
        case CompanySuggestionEnum.ACTIVE:
            return COLORS.constantLightApple;
        case CompanySuggestionEnum.LIQUIDATED:
            return COLORS.constantLightOrange;
        case CompanySuggestionEnum.BANKRUPT:
        case CompanySuggestionEnum.LIQUIDATION:
        case CompanySuggestionEnum.REORGANIZATION:
            return COLORS.constantGreyscale200;
        default: {
            return COLORS.constantGreyscale200;
        }
    }
};
